import { Type } from "@angular/core";
import { FormularGroupTabContentComponent } from "./tab-content.interface";
import {
  FORMULAR_GROUP_ARTIKEL_TYPE,
  FORMULAR_GROUP_BERICHTE_TYPE,
  FORMULAR_GROUP_DYNAMIC_FIELDS_TYPE,
  FORMULAR_GROUP_INPUTS_TYPE,
  FORMULAR_GROUP_STAMM_TYPE,
  FORMULAR_GROUP_WARTUNGEN_TYPE,
  FORMULAR_GROUP_ZEITERFASSUNG_TYPE,
} from "../../formular-model/common/formular-group-types";
import { FormularGroupTabStammComponent } from "./stamm/stamm.component";
import { FormularGroupTabInputsComponent } from "./inputs/inputs.component";
import { FormularGroupTabWartungenComponent } from "./wartungen/wartungen.component";
import { FormularGroupArtikelComponent } from "./artikel/artikel.component";
import { FormularGroupTabBerichteComponent } from "./berichte/berichte.component";
import { FormularGroupTabDynamicFieldsComponent } from "./dynamicfields/dynamicfields.component";
import { FormularGroupTabZeiterfassungComponent } from "./zeiterfassung/zeiterfassung.component";

export const TAB_TYPE_MAP = new Map<
  string,
  Type<FormularGroupTabContentComponent>
>([
  [FORMULAR_GROUP_STAMM_TYPE, FormularGroupTabStammComponent],
  [FORMULAR_GROUP_INPUTS_TYPE, FormularGroupTabInputsComponent],
  [FORMULAR_GROUP_WARTUNGEN_TYPE, FormularGroupTabWartungenComponent],
  [FORMULAR_GROUP_ZEITERFASSUNG_TYPE, FormularGroupTabZeiterfassungComponent],
  [FORMULAR_GROUP_BERICHTE_TYPE, FormularGroupTabBerichteComponent],
  [FORMULAR_GROUP_DYNAMIC_FIELDS_TYPE, FormularGroupTabDynamicFieldsComponent],
  [FORMULAR_GROUP_ARTIKEL_TYPE, FormularGroupArtikelComponent],
]);
